import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0dfadb48")

_pushScopeId("data-v-0dfadb48")
const _hoisted_1 = { class: "ExpressLink" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Отследить ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "ExpressLink__link",
      to: `/tracking/${_ctx.id}`,
      target: "_blank",
      rel: "noreffer"
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["to"])
  ]))
})